import { ILegendPlugin } from '@/shared/Charting/LineChart/lineChart.types.ts'
import LineChart from '@/shared/Charting/LineChart'
import css from './lineChartLegend.module.css'
import lineChartLegendUtils from '@/shared/Charting/LineChart/plugins/LineChartLegendPlugin/lineChartLegend.utils.ts'

const LineChartLegendPlugin: () => ILegendPlugin = () => ({
  chart: null,
  ref: null,
  _interceptors: [],
  _renderPrevented: false,
  setRef(legendElementRef) {
    this.ref = legendElementRef
  },
  init(chart: LineChart) {
    this.chart = chart
  },
  addInterceptor(interceptor) {
    if (!this._interceptors.some((i) => i.id === interceptor.id)) {
      this._interceptors.push(interceptor)
    }
  },
  onMouseMove(e) {
    if (!this.ref.current) {
      return
    }

    // Исполняем интерцепторы
    for (const interceptor of this._interceptors) {
      if (interceptor.kind === 'prevent-render') {
        const result = interceptor.interceptor(e)

        if (!result) {
          this.ref.current.style.display = 'none'
          this._renderPrevented = true
          return
        }
      }
    }

    this._renderPrevented = false
    const rect = this.chart.canvas.getBoundingClientRect()
    const mouse = { x: e.clientX - rect.left, y: e.clientY - rect.top }

    // Не отображаем легенду когда мышка вышла за пределы графика
    if (
      mouse.y < this.chart.paddings.top ||
      mouse.y > this.chart.canvas.height - this.chart.paddings.bottom ||
      mouse.x < this.chart.paddings.left ||
      mouse.x > this.chart.canvas.width - this.chart.paddings.right
    ) {
      this.ref.current.style.display = 'none'
      return
    }

    this.ref.current.style.display = 'block'

    if (mouse.x > this.chart.canvas.width / 1.8) {
      this.ref.current.style.left = ''
      this.ref.current.style.right = this.chart.canvas.width - mouse.x + 20 + 'px'
    } else {
      this.ref.current.style.right = ''
      this.ref.current.style.left = mouse.x + 20 + 'px'
    }

    if (mouse.y < this.chart.canvas.height / 1.7) {
      this.ref.current.style.bottom = ''
      this.ref.current.style.top = mouse.y + 20 + 'px'
    } else {
      this.ref.current.style.top = ''
      this.ref.current.style.bottom = this.chart.canvas.height - mouse.y + 20 + 'px'
    }

    const ts = this.chart.getXValue(mouse.x)
    const closestValues = lineChartLegendUtils.findClosestValue(ts, this.chart.data.datasets)

    for (const closestValue of closestValues) {
      const el = this.ref.current.querySelector(`[data-id="${closestValue.datasetId}"]`)
      if (!el) continue

      if (closestValue.dataType === 'boolean') {
        if (closestValue.value === 0) {
          this.ref.current
            .querySelector(`[data-dataset-id="${closestValue.datasetId}"]`)
            ?.setAttribute('style', 'display: none')
        } else {
          this.ref.current
            .querySelector(`[data-dataset-id="${closestValue.datasetId}"]`)
            ?.setAttribute('style', 'display: inline-flex')
        }
      }

      el.innerHTML = closestValue.value.toFixed(2)
    }
  },
  onMouseLeave() {
    if (!this.ref.current) {
      return
    }

    this.ref.current.style.display = 'none'
  },
  renderLegend() {
    return (
      <div className={css.legend} ref={this.ref}>
        <div className="flex-lines gap4">
          {this.chart.data.datasets.map((d) => (
            <div key={d.label} className="inline-flex-gap gap8 center" data-dataset-id={d.id}>
              <div className={css.legendPoint} style={{ backgroundColor: d.color }} />
              <p className="text-nm">{d.label}:</p>
              <p className="text-nm" data-id={d.id}></p>
            </div>
          ))}
        </div>
      </div>
    )
  },
})

export default LineChartLegendPlugin
